var _style, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGermlang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{fill:#FFDA44;}\r\n\t.st2{fill:#D80027;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    y: -0.1,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1,21.4c2.3,6.1,8.1,10.4,15,10.4s12.7-4.3,15-10.4L16,20L1,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16-0.1C9.1-0.1,3.2,4.2,1,10.3l15,1.4l15-1.4C28.7,4.2,22.9-0.1,16-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1,10.3c-0.6,1.7-1,3.6-1,5.6c0,2,0.4,3.8,1,5.6h30c0.6-1.7,1-3.6,1-5.6c0-2-0.4-3.8-1-5.6H1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermlang);
export default __webpack_public_path__ + "static/media/germlang.478e8cf19b0e6c20abf6bc5482b19027.svg";
export { ForwardRef as ReactComponent };